var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-markdown',{attrs:{"source":_vm.text,"html":false,"emoji":true,"prerender":_vm.preMessageRender,"postrender":_vm.postMessageRender}})}
var staticRenderFns = []

export { render, staticRenderFns }